import React from "react";
import { Box } from "@mui/material";
import SubTitle from "../../components/common/SubTitle";
import AppSettings from "../../components/appSettings/AppSettings";
import TitleBar from "../../components/navbar/TitleBar";
import Footer from "../../components/common/Footer";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";
import { PAGE_IDS, isJsonDrivenLayoutEnabled } from "../../config/uiLayoutConfig";
import { usePageLayout } from "../../context/LayoutContext";
import { getPageTitleKey } from "../../layout/settingsLayoutUtils";

export default function SchoolSettingsContainer() {
  const useJsonLayout = isJsonDrivenLayoutEnabled();
  const { layout: moduleLayout } = usePageLayout(
    useJsonLayout ? PAGE_IDS.SCHOOL_SETTINGS : null,
  );
  const pageTitle = getPageTitleKey(moduleLayout) || "Settings";

  return (
    <>
      <Box>
        <TitleBar />
        <SchoolBusNavMenu />
        <SubTitle title={pageTitle} />
        <AppSettings school={true} />
      </Box>
      <Footer />
    </>
  );
}
